import { Fragment } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import clsx from 'clsx';

import { useAuth } from '../contexts/AuthContext';
import { NAV_SECTIONS } from './navConfig';
import '../styles/dashboard.css';

export default function DashboardLayout() {
  const location = useLocation();
  const { user, signOut } = useAuth();

  return (
    <div className="dashboard-layout">
      <aside className="dashboard-sidebar">
        <div className="sidebar-header">
          <span className="sidebar-logo" aria-hidden>
            <span>L</span>
          </span>
          <div>
            <p className="sidebar-title">Lido Yönetim</p>
            <p className="sidebar-subtitle">Kontrol Merkezi</p>
          </div>
        </div>
        <nav className="sidebar-nav" aria-label="Ana menü">
          {NAV_SECTIONS.map((section) => (
            <Fragment key={section.label}>
              <p className="sidebar-section-label">{section.label}</p>
              <ul>
                {section.items.map((item) => (
                  <li key={item.to}>
                    <NavLink
                      to={item.to}
                      className={({ isActive }) =>
                        clsx('sidebar-link', {
                          active: isActive || (item.exact && location.pathname === item.to),
                        })
                      }
                      end={item.exact}
                    >
                      <span className="sidebar-link-icon" aria-hidden>
                        {item.icon}
                      </span>
                      <span>{item.label}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </Fragment>
          ))}
        </nav>
      </aside>
      <div className="dashboard-main">
        <header className="dashboard-topbar">
          <div className="topbar-breadcrumb">
            <span>Tekrar hoş geldin</span>
            <strong>{user?.email ?? 'Admin'}</strong>
          </div>
          <div className="topbar-actions">
            <span className="user-badge" aria-hidden>
              {user?.email?.[0]?.toUpperCase() ?? 'A'}
            </span>
            <button
              type="button"
              className="signout-button"
              onClick={() => {
                void signOut();
              }}
            >
              Çıkış Yap
            </button>
          </div>
        </header>
        <main className="dashboard-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
